{
  "header": {
    "title": "Perfil",
    "description": "Administra tu cuenta de usuario"
  },
  "tabs": {
    "settings": {
      "label": "Configuración",
      "saveChangeButton": "Guardar cambios",
      "photoSection": {
        "title": "Foto",
        "changePhotoButton": "Cambiar foto",
        "maxSize": "Máx. 5 MB",
        "format": "Formato PNG, JPG"
      },
      "personalInformationSection": {
        "title": "Información personal",
        "nonEditable": {
          "nameInput": { "label": "Nombre" },
          "jobTitleInput": { "label": "Puesto de trabajo" },
          "managerNameInput": { "label": "Nombre del gerente" },
          "userRoleInput": { "label": "Rol de usuario" },
          "emailInput": { "label": "Correo electrónico" },
          "departmentInput": { "label": "Departamento" },
          "tenureInput": { "label": "Antigüedad" }
        },
        "editable": {
          "languageInput": { "label": "Idioma" },
          "dateFormatInput": { "label": "Formato de fecha" },
          "locationInput": { "label": "Ubicación" },
          "timeZoneInput": { "label": "Zona horaria" }
        }
      },
      "emailPreferencesSection": {
        "weeklyDigest": "Enviar un resumen semanal por correo de preguntas recientes",
        "monthlyDigest": "Enviar un resumen mensual por correo con tus aportes"
      }
    },
    "directReports": {
      "label": "Mis subordinados directos",
      "emptyState": {
        "title": "Sin subordinados directos",
        "description": "Aún no tienes subordinados directos asignados. Cuando haya personas a tu cargo, aparecerán aquí."
      },
      "error": {
        "title": "No se pudieron cargar los subordinados directos",
        "description": "Algo salió mal al cargar tus subordinados directos. Inténtalo de nuevo.",
        "retry": "Reintentar"
      }
    }
  }
}
